import { supabase } from './supabase'

export const MODULOS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'voluntarios', label: 'Voluntarios' },
  { id: 'afectados', label: 'Afectados' },
  { id: 'inventario', label: 'Inventario (Dashboard)' },
  { id: 'inventario_insumos', label: 'Insumos' },
  { id: 'inventario_categorias', label: 'Categorías' },
  { id: 'inventario_centros', label: 'Centros de Acopio' },
  { id: 'inventario_donaciones', label: 'Recibir Donación' },
  { id: 'inventario_ingresos', label: 'Ingresos' },
  { id: 'inventario_salidas', label: 'Salidas' },
  { id: 'inventario_ajustes', label: 'Ajustes' },
  { id: 'inventario_traslados', label: 'Traslados' },
  { id: 'inventario_existencias', label: 'Existencias' },
  { id: 'inventario_kardex', label: 'Kardex' },
  { id: 'entregas', label: 'Hacer Donación' },
  { id: 'configuracion', label: 'Configuración' },
  { id: 'permisos', label: 'Permisos' },
]

export const PERMISOS_DISPONIBLES = ['ver', 'crear', 'editar', 'eliminar']

export const ROLES = ['admin', 'voluntario']

export const getPermisosByRol = async (rol) => {
  const { data, error } = await supabase
    .from('permisos_roles')
    .select('*')
    .eq('rol', rol)
  if (error) throw error
  return data || []
}

export const getPermisosByModulo = async (modulo) => {
  const { data, error } = await supabase
    .from('permisos_roles')
    .select('*')
    .eq('modulo', modulo)
  if (error) throw error
  return data || []
}

export const tienePermiso = async (rol, modulo, permiso) => {
  if (rol === 'admin') return true // Admin tiene todos los permisos
  const { data, error } = await supabase
    .from('permisos_roles')
    .select('id')
    .eq('rol', rol)
    .eq('modulo', modulo)
    .eq('permiso', permiso)
    .eq('activo', true)
    .maybeSingle()
  if (error) return false
  return !!data
}

export const actualizarPermiso = async (rol, modulo, permiso, activo) => {
  // Upsert: si existe, actualiza; si no, inserta
  const { data, error } = await supabase
    .from('permisos_roles')
    .upsert({
      rol,
      modulo,
      permiso,
      activo,
      updated_at: new Date().toISOString()
    }, {
      onConflict: 'rol, modulo, permiso',
      ignoreDuplicates: false
    })
    .select()
    .single()
  if (error) throw error
  return data
}

export const obtenerTodosPermisos = async () => {
  const { data, error } = await supabase
    .from('permisos_roles')
    .select('*')
    .order('rol')
    .order('modulo')
    .order('permiso')
  if (error) throw error
  return data || []
}

export const getRolDelUsuario = async () => {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return null
  const { data, error } = await supabase
    .from('voluntarios')
    .select('rol')
    .eq('auth_id', user.id)
    .single()
  if (error) return 'voluntario'
  return data?.rol || 'voluntario'
}